import { Icons } from '@/components/Shares/Icons';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { ActionIcon, Box, Divider, Flex, Image, Stack, Text, Tooltip } from '@mantine/core';
import classes from './Divider.module.css';
import { KycCharacter } from './KycCharacter';
export const KycWelcome: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack h="calc(100vh - 220px)" gap={10} p={{
    base: 24,
    sm: 10
  }} style={{
    overflow: 'auto'
  }}>
      <Flex direction="column" align={{
      base: 'center',
      lg: 'start'
    }} mt={40}>
        <Text fz={24} className={gunterzBold.className}>
          {i18n._('Welcome to')}
        </Text>
        <Image src="/assets/kyc/prime.svg" alt="logo" w={{
        base: 174,
        sm: 160,
        lg: 189
      }} h={{
        base: 62,
        lg: 67
      }} />
      </Flex>
      <Divider my={14} classNames={classes} />
      <Box>
        <Text fz={{
        sm: 18,
        lg: 21
      }} c="var(--text-dark)" className={gunterzBold.className} ta={{
        base: 'center',
        lg: 'left'
      }} style={{
        wordBreak: 'break-word'
      }}>
          {i18n._(`You've unlocked your first `)}
          <Text span inherit c="var(--text-prime)" style={{
          textWrap: 'nowrap'
        }}>
            {i18n._('PrimeOrb')}
            <Tooltip inline label="primeroll">
              <ActionIcon variant="transparent" visibleFrom="lg">
                <Icons className="icon-pr-flat-question-mark" color="var(--text-dark)" fontSize={15} />
              </ActionIcon>
            </Tooltip>
          </Text>
        </Text>
        <Text fz={{
        sm: 18,
        lg: 21
      }} c="var(--text-dark)" className={gunterzBold.className} ta={{
        base: 'center',
        lg: 'left'
      }}>
          {i18n._(' —a unique Emissary Scout with sleek fur.')}
        </Text>
      </Box>
      <Divider my={14} classNames={classes} />
      <Text fz={{
      sm: 18,
      lg: 21
    }} c="var(--text-prime)" className={gunterzBold.className} ta={{
      base: 'center',
      lg: 'left'
    }}>
        {i18n._('This is just the beginning of your journey.')}
      </Text>
      <KycCharacter visible="sm" hidden="lg" />
    </Stack>;
};